import * as React from 'react';
import { useContext } from "react";
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import { Spinner, Text } from "@fluentui/react-components";
import { CustomField } from '../field.js';
import { API_PATH } from '../Constants.ts';
import { fetchConfig } from '../utils/fetchScenarioConfiguration.ts';
const config = await fetchConfig();

let v = 0;

export const ScenarioConfiguration = () => {
    const [configuration, setConfiguration] = React.useState(null);
    const [scenarios, setScenarios] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const isAdministrator = patientId => patientId.toString() === '1'; // EkhiAdmin (role 'administrator')
    const { selectedPatientId } = useContext(SelectedPatientContext);

    React.useEffect(() => {
        if (selectedPatientId===0) return;
        if (isNaN(selectedPatientId) || selectedPatientId < 0){
            console.error("[ScenarioConfiguration useEffect()] Invalid patient id: " + selectedPatientId);
            return;
        }

        const fetchAllowedScenariosForPatient = () => {
            if (isAdministrator(selectedPatientId)) {
                setScenarios(config.scenarios);
                return;
            }

            fetch(API_PATH.SET_ASSIGNABLE_SCENARIOS + `?query=(patient_id==${encodeURIComponent(selectedPatientId)})&columns[]=scenario_id&raw_data`)
            .then(response => response.json())
            .then(allowedScenariosIds => {
                const allowedScenarios = config.scenarios.filter(scenario => allowedScenariosIds.includes(scenario.id));
                setScenarios(allowedScenarios);
            })
            .catch(error => {
            console.error(error);
            alert("An error occurred while reading scenarios state (selected/deselected) for current patient. Please reload the page to continue.");
            });
        }

        setIsLoading(true);
        fetchAllowedScenariosForPatient()
        setIsLoading(false);
    }, [selectedPatientId]);

    function handleChange(i, value) {
        let x = configuration.map((config, index) => {
            return index === i ? { ...config, value: value, } : config;
        });
        setConfiguration(x)
        SaveConfig(x);
    }
    function serialize(obj) {
        var str = [];
        for (var p in obj)
          if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        return str.join("&");
      }
      
    function SaveConfig(configuration){
        let jsonConfig = {scenario:v-1};

        if(configuration){
            configuration.forEach(element => {
                jsonConfig[element.name] = element.value;
            });
        }

        const requestOptions = {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                configuration: JSON.stringify(jsonConfig)
            })
        };

        fetch(API_PATH.CONFIGURATIONS + `?id=${selectedPatientId}`, requestOptions)
        .then(async response => {
            console.log(serialize(response)); // TODO
        })
        .catch(error => {
            console.log(serialize(error)); // TODO
        });
    }

    function handleScenarioChange(value) {
        v = value;
        let x = null;
        setConfiguration(null);
        if (value > 0) {
            let c = config.scenarios[value - 1].properties;
            x = c;
            setConfiguration(c);
        }
        SaveConfig(x);
    }

    return <>
        {isLoading && <Spinner size="small" label="Loading..." />}
        {<CustomField property={{ value: v, type: 'enum_with_id_and_name', label: 'Scenario', values: [{id: 0, name: ' - none - '}, ...scenarios] }} onChange={(e) => { handleScenarioChange(e) }} />}
        {configuration && configuration.map((property, index) => (<CustomField key={v + property.name} property={property} onChange={(e) => handleChange(index, e)} />))}
    </>;
};